import React from "react";

export default function Principles() {
  return (
    <section id="principles" className="principles section section-dark">
      <div className="container">
        <div className="content-wrapper">
          <h3>Важно!</h3>
          <div className="text-content">
            <p>
              Я специализируюсь на индивидуальной разработке с использованием современных технологий <strong>{'(React, Next.js)'}</strong>.
            </p>
            <p>
              Это гарантирует высокое качество, гибкость и масштабируемость вашего продукта в будущем.
            </p>
            <p>
              В работе я придерживаюсь современных стандартов качества кода, включая использование TypeScript там, где это необходимо для обеспечения надёжности проекта.
            </p>
            <p className="highlight-box">
              Обратите внимание: я не работаю с конструкторами сайтов <strong>{'(Tilda, Wix)'}</strong> и шаблонными решениями.
            </p>
            <p>
              Такой подход позволяет создавать уникальные решения без ограничений шаблонных платформ.
            </p>
          </div>
          <a href="#contact" className="btn-primary">
            Обсудить проект
            <span className="arrow">→</span>
          </a>
        </div>
      </div>
      
      <style>{`

        .principles .container {
          max-width: 800px;
        }

        .principles .content-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          background: linear-gradient(135deg, rgba(30, 41, 59, 0.5) 0%, rgba(15, 23, 42, 0.4) 50%, rgba(0, 0, 0, 0.3) 100%);
          backdrop-filter: blur(15px);
          border: 2px solid #60a5fa;
          border-radius: 24px;
          padding: 3rem;
        }

        .principles h3 {
          font-size: 2rem;
          font-weight: 800;
          color: #ffffff;
          margin-bottom: 2rem;
          text-align: center;
          letter-spacing: -0.02em;
        }

        .principles .text-content {
          margin-bottom: 2.5rem;
        }

        .principles p {
          font-size: 1.05rem;
          color: #e2e8f0;
          line-height: 1.8;
          margin-bottom: 1.5rem;
          text-align: left;
        }

        .principles p:last-of-type {
          margin-bottom: 0;
        }

        .principles strong {
          color: #2575fc;
          font-weight: 700;
          position: relative;
          padding: 0 0.2rem;
        }

        .principles .highlight-box {
          background: linear-gradient(135deg, rgba(37, 99, 235, 0.15) 0%, rgba(30, 64, 175, 0.1) 100%);
          border-left: 4px solid #2575fc;
          border-radius: 12px;
          padding: 1.25rem 1.5rem;
          margin: 2rem 0;
        }

        .principles a.btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          margin: 0 auto;
          padding: 1rem 2.5rem;
          font-size: 1.05rem;
          font-weight: 700;
          color: white;
          background: #2575fc;
          border-radius: 12px;
          text-decoration: none;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .principles a.btn-primary::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          transition: left 0.5s ease;
        }

        .principles a.btn-primary:hover::before {
          left: 100%;
        }

        .principles a.btn-primary:hover {
          transform: translateY(-4px);
          box-shadow:
            0 25px 50px rgba(0, 0, 0, 0.4),
            0 0 80px rgba(37, 99, 235, 0.4),
            0 0 120px rgba(96, 165, 250, 0.3),
            inset 0 1px 0 rgba(255, 255, 255, 0.2);
        }

        .principles a.btn-primary .arrow {
          transition: transform 0.3s ease;
          font-size: 1.2rem;
        }

        .principles a.btn-primary:hover .arrow {
          transform: translateX(4px);
        }

        /* Адаптивность для мобильных устройств */
        @media (max-width: 768px) {
          .principles {
            padding: 3rem 0;
          }

          .principles .content-wrapper {
            padding: 2rem 1.5rem;
            border-radius: 16px;
          }

          .principles h3 {
            font-size: 1.5rem;
            margin-bottom: 1.5rem;
          }

          .principles p {
            font-size: 0.95rem;
            margin-bottom: 1.25rem;
          }

          .principles .highlight-box {
            padding: 1rem 1.25rem;
            margin: 1.5rem 0;
          }

          .principles a.btn-primary {
            padding: 0.9rem 2rem;
            font-size: 0.95rem;
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </section>
  );
}